<template>
  <div>
    <div class="newRow">
      <div style="display: flex">
        <span>Contract Setting</span>
      </div>

      <div style="display: flex" v-if="OrderUnit == 'BUS'">
        <base-radio
          inline
          name="contract-type"
          value="media"
          v-model="Contract.contractType"
          :disabled="disabled || HasRevise"
          @change="changeContractType"
          >Media</base-radio
        >
        <base-radio
          inline
          name="contract-type"
          value="production"
          v-model="Contract.contractType"
          :disabled="disabled || HasRevise"
          @change="changeContractType"
          >Production (Exclude App)</base-radio
        >
        <base-radio
          inline
          name="contract-type"
          value="media+production"
          v-model="Contract.contractType"
          :disabled="disabled || HasRevise"
          @change="changeContractType"
          >Media + Production (Bus Body Only)</base-radio
        >
        <base-radio
          inline
          name="contract-type"
          value="media&production"
          v-model="Contract.contractType"
          :disabled="disabled || HasRevise"
          @change="changeContractType"
          >Media & Production (Bus Shelter Only)</base-radio
        >
      </div>
      <div style="display: flex" v-if="OrderUnit == 'BB'">
        <base-radio
          inline
          name="contract-type"
          value="media"
          v-model="Contract.contractType"
          :disabled="disabled || HasRevise"
          @change="changeContractType"
          >Media</base-radio
        >
        <base-radio
          inline
          name="contract-type"
          value="production"
          v-model="Contract.contractType"
          :disabled="disabled || HasRevise"
          @change="changeContractType"
          >Production</base-radio
        >
      </div>
    </div>
    <!-- Company Entity Code -->
    <div style="display: flex; width: 100%">
      <div
        :class="{
          'company-entity-item': true,
          'company-entity-field': true,
          media: !useContractInfo.isMediaProductionPlus,
          'media-production-plus': useContractInfo.isMediaProductionPlus,
        }"
        v-if="useContractInfo.isMedia || useContractInfo.isMediaProductionPlus"
      >
        <base-input label="Company Entity" style="width: 100%">
          <el-select
            class="select-primary"
            size="large"
            placeholder="Company Entity"
            v-model="Contract.mediaCompanyEntityCode"
            filterable
            style="width: 100%"
            :disabled="disabled"
          >
            <el-option label="AA" value="AA"></el-option>
            <el-option label="AM" value="AM"></el-option>
          </el-select>
        </base-input>
      </div>
      <div
        :class="{
          'company-entity-item': true,
          'company-entity-field': true,
          production: true,
        }"
        v-if="useContractInfo.isProduction"
      >
        <base-input label="Company Entity" style="width: 100%">
          <el-select
            class="select-primary"
            size="large"
            placeholder="Company Entity"
            v-model="Contract.productionCompanyEntityCode"
            filterable
            style="width: 100%"
            :disabled="disabled || Contract.isRevised"
          >
            <el-option label="AA" value="AA"></el-option>
            <el-option label="AM" value="AM"></el-option>
            <el-option label="GP" value="GP"></el-option>
          </el-select>
        </base-input>
      </div>
    </div>
    <!-- Media Setting -->
    <div class="newRow">
      <div style="display: flex">
        <span>Media</span>
      </div>
      <div style="display: flex">
        <base-radio
          inline
          name="media-booking-type"
          value="newbooking"
          v-model="ContractBooking.mediaBookingType"
          :disabled="disabled || useContractInfo.mediaDisabled"
          @change="changeMediaRenewalStatus"
          >New Booking</base-radio
        >
        <base-radio
          inline
          name="media-booking-type"
          value="renewal"
          v-model="ContractBooking.mediaBookingType"
          :disabled="disabled || useContractInfo.mediaDisabled"
          @change="changeMediaRenewalStatus"
          >Renewal</base-radio
        >
      </div>
    </div>
    <div style="display: flex">
      <base-input
        label="Renewal Related Media Contract No."
        style="width: 70%"
        :required="true"
        :disabled="disabled || useContractInfo.mediaRenewalDisabled"
        v-model="ContractBooking.mediaRelateContractNumber"
        :class="{
          'has-error':
            ContractBooking.validate &&
            validation.isError(
              ContractBooking.validate,
              'mediaRelateContractNumber'
            ),
        }"
      >
      </base-input>
    </div>
    <!-- Production Setting -->
    <div class="newRow">
      <div style="display: flex">
        <span>Production</span>
      </div>
      <div style="display: flex">
        <base-radio
          inline
          value="newbooking"
          v-model="productionBookingType1"
          :disabled="disabled || useContractInfo.productionDisabled"
          :unChecked="productionBookingClick1"
          @change="productionBookingChanged"
          >New Booking</base-radio
        >
      </div>
      <div style="display: flex">
        <base-radio
          inline
          name="production-booking-type"
          value="pid"
          v-model="productionBookingType2"
          :disabled="disabled || useContractInfo.productionDisabled"
          :unChecked="productionBookingClick2"
          @change="productionBookingChanged"
          >P+I+D</base-radio
        >
        <base-radio
          inline
          name="production-booking-type"
          value="id"
          v-model="productionBookingType2"
          :disabled="disabled || useContractInfo.productionDisabled"
          :unChecked="productionBookingClick2"
          @change="productionBookingChanged"
          >I+D</base-radio
        >
        <base-radio
          inline
          name="production-booking-type"
          value="p"
          v-model="productionBookingType2"
          :disabled="disabled || useContractInfo.productionDisabled"
          :unChecked="productionBookingClick2"
          @change="productionBookingChanged"
          >P Only</base-radio
        >
      </div>
      <div style="display: flex">
        <base-radio
          inline
          value="newvisual"
          v-model="productionBookingType3"
          :disabled="disabled || useContractInfo.productionDisabled"
          :unChecked="productionBookingClick3"
          @change="productionBookingChanged"
          >Media Extension</base-radio
        >
      </div>
    </div>
    <div style="display: flex">
      <base-input
        label="Related Media Contract No."
        style="width: 70%"
        :required="true"
        :disabled="disabled || useContractInfo.productionRenewalDisabled"
        v-model="ContractBooking.productionRelateContractNumber"
        :class="{
          'has-error':
            ContractBooking.validate &&
            validation.isError(
              ContractBooking.validate,
              'productionRelateContractNumber'
            ),
        }"
      >
      </base-input>
    </div>

    <div style="display: flex; margin-top: 30px">
      <base-input
        label="Intercom Contract No."
        style="width: 70%"
        :required="true"
        v-if="ContractSummary.isITC"
        :disabled="disabled"
        v-model="ContractBooking.intercomContractNumber"
        :class="{
          'has-error':
            ContractBooking.validate &&
            validation.isError(
              ContractBooking.validate,
              'intercomContractNumber'
            ),
        }"
      >
      </base-input>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseRadio from '@/components/newUI/Inputs/BaseRadio';
import { storeToRefs } from 'pinia';
import { useContractInfoStore } from '@/store/contractinfo';
import { useContractStore } from '@/store/contract';
import validation from '@/assets/js/validation';

const useContractInfo = useContractInfoStore();
const { Contract, ContractBooking } = storeToRefs(useContractInfo);
const useContract = useContractStore();
const { ContractSummary } = storeToRefs(useContract);

const props = defineProps({
  disabled: {
    type: Boolean,
  },
  HasRevise: {
    type: Boolean,
    default: false,
  },
});

const OrderUnit = ref('BB');

const productionBookingType1 = ref('');
const productionBookingType2 = ref('');
const productionBookingType3 = ref('');
await useContractInfo.RefreshContractInfo();
const BookingTypes = (
  ContractBooking.value.productionBookingType || '>>'
).split('>');
productionBookingType1.value = BookingTypes.length > 0 ? BookingTypes[0] : '';
productionBookingType2.value = BookingTypes.length > 1 ? BookingTypes[1] : '';
productionBookingType3.value = BookingTypes.length > 2 ? BookingTypes[2] : '';

const changeContractType = () => {
  // Company Entity
  if (OrderUnit.value === 'BB') {
    Contract.value.mediaCompanyEntityCode = useContractInfo.isMedia ? 'AA' : '';
    Contract.value.productionCompanyEntityCode = useContractInfo.isProduction
      ? 'GP'
      : '';
  } else {
    Contract.value.mediaCompanyEntityCode = useContractInfo.isMedia ? 'BM' : '';
    Contract.value.productionCompanyEntityCode = useContractInfo.isProduction
      ? 'BU'
      : '';
  }

  // Disabled
  changeMediaStatus();
  changeMediaRenewalStatus();

  changeProductionStatus();
  changeNewVisualStatus();
};
const changeMediaStatus = () => {
  if (useContractInfo.mediaDisabled) {
    ContractBooking.value.mediaBookingType = '';
  }
};
const changeMediaRenewalStatus = () => {
  if (useContractInfo.mediaRenewalDisabled) {
    ContractBooking.value.mediaRelateContractNumber = '';
  }
};
const changeProductionStatus = () => {
  if (useContractInfo.productionDisabled) {
    productionBookingType1.value = '';
    productionBookingType2.value = '';
    productionBookingType3.value = '';

    ContractBooking.value.productionBookingType = '';
  }
};
const changeNewVisualStatus = () => {
  if (useContractInfo.productionRenewalDisabled) {
    ContractBooking.value.productionRelateContractNumber = '';
  }
};
const productionBookingClick1 = () => {
  productionBookingType1.value = '';
  productionBookingChanged();
};
const productionBookingClick2 = () => {
  productionBookingType2.value = '';
  productionBookingChanged();
};
const productionBookingClick3 = () => {
  productionBookingType3.value = '';
  productionBookingChanged();
};
const productionBookingChanged = () => {
  changeProductionBookingType();
  changeNewVisualStatus();
};
const changeProductionBookingType = () => {
  ContractBooking.value.productionBookingType = `${productionBookingType1.value}>${productionBookingType2.value}>${productionBookingType3.value}`;
};
</script>
<style>
.company-entity-item {
  padding-right: 30px;
}

.company-entity-field.production .form-group.has-label label::after {
  content: '【 Production 】';
  color: #d05c5f;
}

.company-entity-field.media .form-group.has-label label::after {
  content: '【 Media 】' !important;
  color: #d05c5f;
}

.company-entity-field.media-production-plus .form-group.has-label label::after {
  content: '【 Media + Production 】';
  color: #d05c5f;
}

.required-sign {
  color: #d05c5f;
}
</style>
